import React from 'react';
import Modal from 'react-modal';
import { AlertTriangle, X } from 'lucide-react';

const DeleteBlockedDateModal = ({
  isOpen,
  onCancel,
  onConfirm,
  dateRange,
  isLoading = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onCancel}
      className="bg-white rounded-lg shadow-2xl max-w-md mx-auto mt-20 p-6 z-50"
      overlayClassName="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-40"
      ariaHideApp={false}
    >
      <div className="space-y-4">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <AlertTriangle size={28} className="text-red-600" />
            <h2 className="text-xl font-bold text-prose-brand">Unblock Dates?</h2>
          </div>
          <button
            onClick={onCancel}
            className="p-1 hover:bg-gray-100 rounded-lg transition duration-200"
          >
            <X size={20} className="text-prose-black/60" />
          </button>
        </div>
        {/* Message */}
        <div className="bg-red-50 border border-red-200 rounded-lg p-3">
          <p className="text-sm text-prose-black/80">
            {dateRange || 'Are you sure you want to unblock these dates?'}
          </p>
        </div>

        {/* Warning */}
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
          <p className="text-xs text-yellow-800">
            This action cannot be undone. These dates will become available for bookings again.
          </p>
        </div>

        {/* Actions */}
        <div className="flex gap-3 pt-4">
          <button
            onClick={onCancel}
            disabled={isLoading}
            className="flex-1 px-4 py-2 border border-gray-300 text-prose-brand rounded-lg hover:bg-gray-100 transition duration-200 font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition duration-200 font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? 'Unblocking...' : 'Unblock'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteBlockedDateModal;
